
import { useEffect } from 'react';
import './CustomModal.css'; // We'll create this CSS file

const ErrorMessage = ({ isOpen, toggle, caption, message }) => {
  // Close modal when pressing Escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.keyCode === 27) {
        toggle();
      }
    };
    document.addEventListener('keydown', handleEscape, false);

    return () => {
      document.removeEventListener('keydown', handleEscape, false);
    };
  }, [toggle]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlays" onClick={toggle}>
      <div className="modal-contents" onClick={(e) => e.stopPropagation()}>
        <div className="modal-headers">
          <h3>{caption}</h3>
          <button onClick={toggle} className="modal-closes">&times;</button>
        </div>
        <div className="modal-bodys model-error">
          <p>{message}</p>
        </div>
        <div className="modal-footers">
          <button onClick={toggle} className="btn-ok">OK</button>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
